/** @jsx jsx */
import { css, keyframes } from '@emotion/core';
import { colorsPalette, shadows } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

const rotateImageIcon = keyframes`
  from { transform: rotate(0deg)}
  to { transform: rotate(359deg) }
`;

export const formStateStyle = {
  DEFAULT: css({}),
  FILLING: css({}),
  PROGRESS: css({
    background: colorsPalette.grey80 + '!important',
    img: {
      animation: `${rotateImageIcon} 2s infinite linear`,
    },
  }),
  SUCCESS: css({
    background: colorsPalette.teal + '!important',
  }),
  ERROR: css({
    background: '#AE0710 !important',
  }),
};

export const common = css({});
